
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"14","viewBox":"0 0 15 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.791 2.875a5.833 5.833 0 10-8.25 8.25 5.833 5.833 0 008.25-8.25zM9.417 8.75a.584.584 0 01-.584-.583V6.658L6.571 8.921a.584.584 0 01-.825-.825l2.263-2.263H6.5a.584.584 0 010-1.166h2.917c.322 0 .583.261.583.583v2.917a.584.584 0 01-.583.583z","fill":"#122546"}})])
          )
        }
      }
    